import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../ui/Select/Select'
import ToggleGroup from '../ui/ToggleGroup'
import { VIEW_MODES } from './constants'

const VIEW_OPTIONS = [
  { value: VIEW_MODES.GRADE, label: 'Note' },
  { value: VIEW_MODES.SATISFACTION, label: 'Taux de Satisfaction (%)' }
]

const ChartControls = ({
  granularity, granularityOptions, onGranularityChange,
  viewMode, onViewModeChange, hasGradeQuestions
}) => {
  const selected = granularityOptions.find(opt => opt.value === granularity) || granularityOptions[0]
  const handleGranularitySelect = useCallback(option => {
    onGranularityChange(option?.value)
  }, [onGranularityChange])

  return (
    <div className="tw:flex tw:items-center tw:gap-3 tw:justify-end">
      <div className="tw:w-48">
        <Select
          isSearchable={false}
          options={granularityOptions}
          value={selected}
          onChange={handleGranularitySelect}
        />
      </div>
      {hasGradeQuestions ? (
        <ToggleGroup
          ariaLabel="Type d'évolution"
          options={VIEW_OPTIONS}
          value={viewMode}
          onChange={onViewModeChange}
        />
      ) : null}
    </div>
  )
}

ChartControls.propTypes = {
  granularity: PropTypes.string.isRequired,
  granularityOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  hasGradeQuestions: PropTypes.bool.isRequired,
  onGranularityChange: PropTypes.func.isRequired,
  onViewModeChange: PropTypes.func.isRequired,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)).isRequired
}

export default ChartControls
